export const POINCARE_SIZE = Math.min(window.innerWidth * 0.8, window.innerHeight * 0.8); 
export const POINCARE_WIDTH = POINCARE_SIZE;
export const POINCARE_HEIGHT = POINCARE_SIZE;

export const POINT_RADIUS = 3;
export const POINT_COLOR = 'black';

export const LINE_WIDTH = 2;
export const LINE_COLOR = 'gray';

export const DEFAULT_P = 5;
export const DEFAULT_Q = 6;